/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.question.QuestionOutcome
*/
export var QuestionOutcome;
(function (QuestionOutcome) {
    QuestionOutcome["ANSWERED"] = "ANSWERED";
    QuestionOutcome["SETTLED"] = "SETTLED";
    QuestionOutcome["LATER"] = "LATER";
    QuestionOutcome["UNKNOWN"] = "UNKNOWN";
})(QuestionOutcome || (QuestionOutcome = {}));
//# sourceMappingURL=QuestionOutcome.js.map